import { BannerResolutionKey } from "./types";

export const BANNER_REVALIDATE_SECONDS = process.env.NEXT_PUBLIC_DEV_MODE === "true" ? 0 : 300;

export const BANNER_DEFAULT_RESOLUTION: BannerResolutionKey = "desktop";

export const BANNER_SLOTS = {
  homePageBanner: "home_banner",
  buyPageFirstBanner: "buy_page_banner_1",
  buyPageSecondBanner: "buy_page_banner_2",
  buyPageThirdBanner: "buy_page_banner_3",
  buyPageFourthBanner: "buy_page_banner_4",
} as const;
